export const breakpoint = {
  xs: 0,
  sm: 360,
  md: 766,
  lg: 1024,
  xl: 1440,
  xml: 1600,
  xxl: 1920,
};
